var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-purchase-tag-alt.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75567 1.91214C9.67839 1.83464 9.58656 1.77317 9.48545 1.73127C9.38434 1.68937 9.27595 1.66786 9.1665 1.66797H4.99984C4.89039 1.66786 4.782 1.68937 4.68089 1.73127C4.57979 1.77317 4.48795 1.83464 4.41067 1.91214L1.91067 4.41214C1.83314 4.48939 1.77165 4.58122 1.72974 4.68233C1.68784 4.78345 1.66635 4.89185 1.6665 5.0013V9.16797C1.6665 9.38964 1.754 9.6013 1.91067 9.75714L10.244 18.0905C10.3212 18.1681 10.413 18.2297 10.5141 18.2718C10.6152 18.3139 10.7237 18.3355 10.8332 18.3355C10.9427 18.3355 11.0511 18.3139 11.1522 18.2718C11.2533 18.2297 11.3451 18.1681 11.4223 18.0905L18.089 11.4238C18.1665 11.3465 18.2279 11.2546 18.2698 11.1535C18.3118 11.0525 18.3333 10.9441 18.3333 10.8346C18.3333 10.7252 18.3118 10.6168 18.2698 10.5157C18.2279 10.4146 18.1665 10.3228 18.089 10.2455L9.75567 1.91214ZM10.8332 16.323L3.33317 8.82297V5.3463L5.34484 3.33464H8.82151L16.3215 10.8346L10.8332 16.323Z",
    fill: "#818CF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.96088 8.33094C7.71889 8.33094 8.33338 7.71645 8.33338 6.95844C8.33338 6.20043 7.71889 5.58594 6.96088 5.58594C6.20287 5.58594 5.58838 6.20043 5.58838 6.95844C5.58838 7.71645 6.20287 8.33094 6.96088 8.33094Z",
    fill: "#818CF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brandIcon.3dea30110b84cfda78b4d877b0f16b0a.svg";
export { ForwardRef as ReactComponent };